import { createContext } from "react";

const BillingAddressContext = createContext();

export default BillingAddressContext;
